// The browser tab belongs to the One Retail shell: it owns the document, so it is the only writer
// - ADR-018 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/018-shell-owns-the-tab-title.md
// Embedded, AO reports the page it is showing and the shell composes
// `{detail} | {product} | One Retail`.

import { watch } from 'vue';
import { APP_KEY, shellBridge } from '@/webshell-embed/platform-bridge';

// `null` hands the tab back to the shell's own fallback rather than leaving a stale page name.
export function reportTabTitleDetail(detail) {
  shellBridge()?.tabTitle.set(APP_KEY, detail || null);
}

// Resolving inside the getter makes the store reads dependencies, so the detail re-reports once the
// entity loads. A primitive return, so an unchanged detail reports once.
export function watchAndReportTabTitle(currentRoute, resolve) {
  return watch(() => resolve(currentRoute()) || null, reportTabTitleDetail, { immediate: true });
}
